class TabController {
  constructor() {
    this.init();
  }

  init() {
    const tabContainers = document.querySelectorAll('.tab-container');
    tabContainers.forEach(container => {
      const tabs = container.querySelectorAll('[role="tab"]');
      const panels = container.querySelectorAll('[role="tabpanel"]');

      // Add click event to tabs
      tabs.forEach(tab => {
        tab.addEventListener('click', () => {
          this.switchTab(tab, tabs, panels);
        });

        // Add keyboard navigation
        tab.addEventListener('keydown', e => {
          const targetTab = this.getTargetTab(e, tab, tabs);
          if (targetTab) {
            this.switchTab(targetTab, tabs, panels);
            targetTab.focus();
          }
        });
      });
    });
  }

  switchTab(targetTab, tabs, panels) {
    // Update selected state on tabs
    tabs.forEach(tab => {
      const isTargetTab = tab === targetTab;
      tab.setAttribute('aria-selected', isTargetTab);
      tab.classList.toggle('is-active', isTargetTab);
    });

    // Show selected panel
    const targetPanelId = targetTab.getAttribute('aria-controls');
    panels.forEach(panel => {
      panel.classList.toggle('is-active', panel.id === targetPanelId);
    });
  }

  getTargetTab(e, currentTab, tabs) {
    const tabArray = Array.from(tabs);
    const index = tabArray.indexOf(currentTab);
    
    switch(e.key) {
      case 'ArrowLeft':
        return tabArray[index - 1] || tabArray[tabArray.length - 1];
      case 'ArrowRight':
        return tabArray[index + 1] || tabArray[0];
      default:
        return null;
    }
  }
}

// Initialize tabs when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new TabController();
});